export default "__VITE_ASSET__BviCaOI___"